export class CaptchaService {
	constructor($http, $translate) {
		'ngInject';
		this.$http = $http;
		this.publicRoot = '/public';
	}
	getCaptcha() {
		return this.$http({
			method: 'GET',
			url: `${this.publicRoot}/captcha`
		});
	}
}
